import { Grid, Typography } from "@mui/material";

import CoinSelectItem from "./Component/CoinSelectItem";
import DatePicker from "components/DatePicker";
import Select from "components/Select";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

function FilterMarginHistory({ typeId, historyFormData }) {
  const { setValue, watch } = useFormContext();

  const currentType = useMemo(() => {
    return historyFormData?.lisType?.find((type) => type?.id === typeId);
  }, [historyFormData, typeId]);

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item md={4} xs={12}>
        <Typography variant="label" color="text.secondary">
          From Date
        </Typography>

        <DatePicker
          value={watch("dateFrom")}
          onChange={(e) => {
            setValue("dateFrom", e);
          }}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Typography variant="label" color="text.secondary">
          To Date
        </Typography>

        <DatePicker
          value={watch("dateTo")}
          onChange={(e) => {
            setValue("dateTo", e);
          }}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Typography variant="label" color="text.secondary">
          Coin
        </Typography>

        <Select
          items={historyFormData?.lisCoin}
          value={watch("coinId")}
          itemText="name"
          itemValue="id"
          onChange={(e) => {
            setValue("coinId", e?.target?.value);
          }}
          dir="ltr"
          customValue={(data) => <CoinSelectItem data={data} />}
        />
      </Grid>

      {currentType?.isTypeRepayment && (
        <Grid item md={4} xs={12}>
          <Typography variant="label" color="text.secondary">
            Change Payment
          </Typography>

          <Select
            items={historyFormData?.lisTypeRepayment}
            value={watch("repayId")}
            itemText="name"
            itemValue="id"
            onChange={(e) => setValue("repayId", e?.target?.value)}
            dir="rtl"
          />
        </Grid>
      )}

      {currentType?.isTypeTransfer && (
        <Grid item md={4} xs={12}>
          <Typography variant="label" color="text.secondary">
            Change Transfer
          </Typography>

          <Select
            items={historyFormData?.lisTypeTransfer}
            value={watch("transferId")}
            onChange={(e) => {
              setValue("transferId", e?.target?.value);
            }}
            itemText="name"
            itemValue="id"
            dir="rtl"
          />
        </Grid>
      )}
    </Grid>
  );
}

export default FilterMarginHistory;
